/** @jsx isolateComponent */
import { ServiceIcons } from '@zapier/design-system';
import { DEFAULT_SERVICE_ICON_URL_GREY } from '@zapier/product-get-help/esm';
import { isolateComponent } from '@zapier/style-encapsulation';
const ZapIcons = ({ nodes }) => {
    const servicesMap = nodes.map(node => ({
        name: node.selectedApi || 'App',
        src: node.appImage64 || DEFAULT_SERVICE_ICON_URL_GREY,
    }));
    return isolateComponent(ServiceIcons, { maxServices: 3, services: servicesMap, size: 30 });
};
export default ZapIcons;
